module.exports = __webpack_public_path__ + "static/MISSION10000_QUANTUM_Conference Proceedings-cc37aeebf519c9385e48bead73a332ea.pdf";